import { render, staticRenderFns } from "./RewardAffiliateReport.vue?vue&type=template&id=5a4b28ee&scoped=true"
import script from "./RewardAffiliateReport.vue?vue&type=script&lang=js"
export * from "./RewardAffiliateReport.vue?vue&type=script&lang=js"
import style0 from "./RewardAffiliateReport.vue?vue&type=style&index=0&id=5a4b28ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b28ee",
  null
  
)

export default component.exports